<template>
  <div
    class="threeViewer"
    style="background: linear-gradient(0deg, rgb(246, 250, 255) 10%, rgb(214, 224, 235) 70%);height: 100%;width: 100%;"
  >
    <div id="threeViewer" style="width:100%;height:100%">
      <div
        v-if="status === 'loading'"
        class="loading flex-container flex-row flex-horiz-center flex-verti-center"
        style="background: linear-gradient(0deg, rgb(246, 250, 255) 10%, rgb(214, 224, 235) 70%);height: 100%;width: 100%;"
      >
        <span>{{ $t('3d.loadingModel') }}</span>
      </div>
    </div>
    <div id="iconBox" class="icon-box flex-container flex-row flex-verti-center">
      <i v-if="!shouldShowEyesIcon" class="gjw-iconfont gjw-icon-icon_size-hide disabled" :title="$t('3d.noDimensionInModel')" />
      <i
        v-if="shouldShowEyesIcon && !showDimension"
        class="gjw-iconfont gjw-icon-icon_size-visible"
        :title="$t('3d.showDimension')"
        @click="switchShowDimension(true)"
      />
      <i v-if="shouldShowEyesIcon && showDimension" class="gjw-iconfont gjw-icon-icon_size-hide" :title="$t('3d.hideDimension')" @click="switchShowDimension(false)" />
    </div>
    <div
      v-if="!status || status === 'error'"
      class="noToken flex-container flex-column flex-horiz-center flex-verti-center"
    >
      <span>{{ $t('3d.notSupported') }}</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Viewer } from '@/plugins/three/viewer'
export default {
  props: {
    // 根据条件判断是否要渲染3d
    show: {
      type: Boolean,
      default: false
    },
    api: {
      type: String,
      default: ''
    },
    storeId: {
      type: Number,
      default: null
    },
    coreResourceId: {
      type: [Number, String],
      default: null
    },
    coreResourceVersionId: {
      type: [Number, String],
      default: null
    },
    familyType: {
      type: Object,
      default() {
        return {}
      }
    },
    geometryData: {
      type: Array,
      default() {
        return []
      }
    },
    inputParameters: {
      type: Array,
      default() {
        return []
      }
    }

  },
  data() {
    return {
      app: null,
      status: null,
      viewer: new Viewer(),
      showDimension: false,
      displayData: {},
      currentUuid: null
    }
  },
  computed: {
    ...mapGetters({
      softwareCode: 'softwareCode'
    }),
    // 是否是深化设计软件
    isBimmake() {
      return this.softwareCode === 'bimmake'
    },
    shouldShowEyesIcon() {
      const data = this.displayData || {}
      const nodes = data.nodes ? data.nodes : []
      return nodes.some((item) => { return item.type === 'dimension' })
    }
  },
  watch: {
    'familyType.uuid': {
      handler(newValue) {
        this.currentUuid = newValue
        // 当没有3d数据时，再请求0.44及之前的json文件
        if (JSON.stringify(this.displayData) === '{}') {
          this.getOld3DJson(newValue)
        }
      },
    },
    show: {
      handler(newValue, oldValue) {
        if (newValue === oldValue) { return }
        this.calc3D(this.currentUuid)
      }
    }
  },
  mounted() {
    this.currentUuid = this.familyType ? this.familyType.uuid : null
    this.calc3D(this.currentUuid)
  },
  methods: {
    async calc3D(uuid) {
      if (!this.show) { return }
      // 轮询时，若规格已经发生了变化，无需继续请求接口
      if (uuid !== this.currentUuid) {
        return
      }
      this.status = 'loading'
      try {
        // 先获取固定路径的json文件（0.45版本之后会有），如果获取不到，再通过接口获取json文件地址。（0.44及之前的老逻辑）
        await this.getNew3DJson()
      } catch (err) {
        await this.getOld3DJson(uuid)
      }
    },
    async getNew3DJson() {
      const coreResourceVersionId = this.isBimmake ? '' : `/${this.coreResourceVersionId}`
      const url = `${process.env.VUE_APP_STATIC_HOST}/metadata/${this.coreResourceId}${coreResourceVersionId}/display_data.json.gz`
      const { data } = await axios.get(url, { withCredentials: false })
      this.displayData = data
      this.loadViewer()
    },
    // 0.44及之前版本获取json文件的老逻辑
    async getOld3DJson(uuid) {
      // 轮询时，若规格已经发生了变化，无需继续请求接口
      if (!this.show || uuid !== this.currentUuid) { return }
      try {
        const path = await this.$axios.post(this.api, { storeId: this.storeId, inputParameters: this.inputParameters })
        if (path) {
          const url = `${process.env.VUE_APP_STATIC_HOST}/${path}`
          const { data } = await axios.get(url, { withCredentials: false })
          this.displayData = data
          this.loadViewer()
        } else {
          this.status = 'error'
        }
      } catch (err) {
        this.loadViewerError(err, uuid)
      }
    },
    loadViewer() {
      this.status = 'success'
      this.$nextTick(() => {
        if (JSON.stringify(this.displayData) === '{}') {
          this.status = 'error'
          return
        }
        if (!this.show) { return }
        this.viewer.clear({ clearMount: true })
        this.viewer.init('threeViewer')
        this.viewer.loadGacJson(this.displayData, this.showDimension)
      }, () => {
        this.status = 'error'
      })
    },
    loadViewerError(err, uuid) {
      // console.log(err, err.status, 11)
      if (err && err.status === 504) {
        // 轮询
        this.getOld3DJson(uuid)
      } else {
        this.status = 'error'
      }
    },
    // 是否显示标注
    switchShowDimension(bool) {
      this.showDimension = bool
      this.viewer.clear({ clearMount: true })
      this.viewer.init('threeViewer')
      this.viewer.loadGacJson(this.geometryData, bool)
    }
  },
}
</script>
<style lang="less" scoped>
  .threeViewer {
    position: relative;
    overflow: hidden;
    #threeViewer {
      height: 100%;
      width: 100%;
    }

    .icon-box {
      display: none;
      box-sizing: content-box;
      position: absolute;
      right: 14px;
      bottom: 14px;
      z-index: 99;
      width: 40px;
      height: 40px;
      padding: 10px;
      background: rgba(0, 0, 0, .5);

      .gjw-iconfont {
        font-size: 40px;
        color: #FFFFFF;
        cursor: pointer;
        &:not(.disabled):hover {
          color: @theme-color;
        }
        &.disabled{
          opacity: 0.5;
          cursor: default;
        }
      }
    }

    .noToken,
    .loading {
      border-radius: 4px;
      background: #F5F5FA;
      text-align: center;
      font-size: 14px;
      vertical-align: middle;
      position: absolute;
      width: 100%;height: 100%;
      top: 0;left: 0;
    }

    .noToken {
      img {
        width: 400px;
        max-width: 100%;
      }

      span {
        position: relative;
      }
    }

    .viewer {
      position: absolute;

      .bf-container {
        border-radius: 4px;
      }

      .bf-toolbar-select[title=FamilyTypes] {
        display: none;
      }
    }
  }
</style>
